import React, { useState, useEffect, useRef } from "react";
import styles from "../EditDiv/EditDiv.module.css";
import buttonStyles from "../YesNoButtonsCSS/YesNoButtons.module.css";
import BlueLogo from "../../assets/BlueLogo.png";
import { Grid, TextField } from "@mui/material";
import { useDispatch, useSelector } from "../../redux/store";
import { Form, FormikProvider } from "formik";
import { useFormik } from "formik";
import * as Yup from "yup";
import textfieldStyle from "../../GlobalStyles/styles";
import DropDownV2 from "../DropDownBox/DropdownV2";
import { getRunners } from "../../redux/slices/opportunitiesdata";
import { searchClientsForAttachment } from "../../redux/slices/client";

const EditClientProfilePopup = ({ clientData, onSubmit, onDelete, onClose }) => {
    const dispatch = useDispatch();
    const { runners } = useSelector((state) => state.opportunities);
    const { attachProfessionalOptions, isDeletingClient } = useSelector((state) => state.client);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const backdropRef = useRef(null);
    const formRef = useRef(null);

    useEffect(() => {
        dispatch(getRunners());
    }, [dispatch]);

    // Ensure modal opens scrolled to the top and content is top-aligned
    useEffect(() => {
        if (backdropRef.current) backdropRef.current.scrollTop = 0;
        if (formRef.current) formRef.current.scrollTop = 0;
    }, []);

    const handleFormClick = (e) => {
        e.stopPropagation();
    };

    const clientTypeOptions = [
        { label: "Professional", value: "Professional" },
        { label: "Home Owner", value: "Home Owner" },
        { label: "Company", value: "Company" }
    ];

    const preferredOptions = [
        { label: "Work with - Preferred", value: "Work with - Preferred" },
        { label: "Work with - Not Preferred", value: "Work with - Not Preferred" },
        { label: "Do not work with", value: "Do not work with" }
    ];

    const professionOptions = [
        { label: 'Architect', value: 'Architect' },
        { label: 'Contractor', value: 'Contractor' },
        { label: 'Developer', value: 'Developer' }
    ];

    const initialValues = {
        name: clientData?.name || "",
        email: clientData?.email || "",
        preferredRunner: clientData?.pref_runner ? { label: clientData.pref_runner, value: clientData.pref_runner } : {},
        // Keep as object for Dropdown initial selection
        clientType: clientData?.professional
            ? { label: "Professional", value: "Professional" }
            : clientData?.home_owner
            ? { label: "Home Owner", value: "Home Owner" }
            : clientData?.company
            ? { label: "Company", value: "Company" }
            : {},
        profession: clientData?.profession ? { label: clientData.profession, value: clientData.profession } : {},
        preferred: clientData?.preferred ? { label: clientData.preferred, value: clientData.preferred } : {},
        phoneNo: clientData?.phone_no || "",
        address1: clientData?.address_1 || "",
        address2: clientData?.address_2 || "",
        town: clientData?.town || clientData?.city || "", // Move City to Town if Town is blank
        postCode: clientData?.post_code || "",
        linkedCompanyID: "",
        linkedCompanyName: "",
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: EditClientProfileSchema,
        enableReinitialize: true,
        onSubmit: async (values, { resetForm }) => {
            // Normalize values for submission
            const payload = {
                ...values,
                clientType: typeof values.clientType === 'object' ? values.clientType.value : values.clientType,
                profession: typeof values.profession === 'object' ? values.profession.value : values.profession,
                preferred: typeof values.preferred === 'object' ? values.preferred.value : values.preferred,
                preferredRunner: typeof values.preferredRunner === 'object' ? values.preferredRunner.value : values.preferredRunner,
            };
            onSubmit(payload);
            onClose();
        },
    });

    const { getFieldProps, touched, errors, handleSubmit, setFieldValue, values } = formik;

    const handleProfessionalSearchChange = (searchTerm) => {
        if (!searchTerm) return;
        dispatch(searchClientsForAttachment(searchTerm, "professional"));
    };

    useEffect(() => {
        if (values.clientType?.value !== 'Company') {
            setFieldValue('profession', '');
            setFieldValue('linkedCompanyID', '');
            setFieldValue('linkedCompanyName', '');
        }
    }, [values.clientType, setFieldValue]);

    return (
        <div className={styles.backGround} ref={backdropRef}>
            <div
                className={styles.form}
                ref={formRef}
                style={{
                    width: "500px",
                    maxHeight: "80vh",
                    overflowY: "auto",
                    justifyContent: "flex-start",
                    alignItems: "stretch",
                    paddingTop: 12,
                    paddingBottom: 8,
                }}
                onClick={handleFormClick}
            >
                    <div className={styles.momentTitle}>MOMENT</div>
                    <div className={styles.sectionTitle}>Update Client Profile</div>

                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit} style={{ width: "100%" }}>

                            <Grid container sx={{ width: "100%", mt: 2 }}>
                                <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                    <p className={styles.dataTitleV2}>Name:</p>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        fullWidth
                                        {...getFieldProps('name')}
                                        placeholder="Enter client name"
                                        sx={textfieldStyle}
                                        error={Boolean(touched.name && errors.name)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container sx={{ width: "100%", mt: 2 }}>
                                <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                    <p className={styles.dataTitleV2}>Email:</p>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        fullWidth
                                        {...getFieldProps('email')}
                                        placeholder="Enter email address"
                                        sx={textfieldStyle}
                                        error={Boolean(touched.email && errors.email)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container sx={{ width: "100%", mt: 2 }}>
                                <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                    <p className={styles.dataTitleV2}>Preferred Runner:</p>
                                </Grid>
                                <Grid item xs={9}>
                                    <DropDownV2
                                        options={runners}
                                        initialSelectedValue={values.preferredRunner}
                                        placeholder={"Select..."}
                                        onValueChange={(newValue) => {
                                            setFieldValue("preferredRunner", newValue);
                                        }}
                                        PopUp={true}
                                        errorState={Boolean(touched.preferredRunner && errors.preferredRunner)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container sx={{ width: "100%", mt: 2 }}>
                                <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                    <p className={styles.dataTitleV2}>Client Type:</p>
                                </Grid>
                                <Grid item xs={9}>
                                    <DropDownV2
                                        options={clientTypeOptions}
                                        initialSelectedValue={values.clientType}
                                        placeholder={"Select client type"}
                                        onValueChange={(newValue) => {
                                            setFieldValue("clientType", newValue);
                                        }}
                                        PopUp={true}
                                        errorState={Boolean(touched.clientType && errors.clientType)}
                                    />
                                </Grid>
                            </Grid>

                            {values.clientType?.value === 'Professional' && (
                                <Grid container sx={{ width: "100%", mt: 2 }}>
                                    <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                        <p className={styles.dataTitleV2}>Profession:</p>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <DropDownV2
                                            options={professionOptions}
                                            initialSelectedValue={values.profession}
                                            placeholder={"Select profession"}
                                            onValueChange={(newValue) => {
                                                setFieldValue("profession", newValue);
                                            }}
                                            PopUp={true}
                                            errorState={Boolean(touched.profession && errors.profession)}
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            {values.clientType?.value === 'Company' && (
                                <Grid container sx={{ width: "100%", mt: 2 }}>
                                    <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                        <p className={styles.dataTitleV2}>Primary Professional (optional):</p>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <DropDownV2
                                            options={attachProfessionalOptions}
                                            initialSelectedValue={
                                                values.linkedCompanyID
                                                    ? attachProfessionalOptions.find((o) => o.value === values.linkedCompanyID) || {}
                                                    : {}
                                            }
                                            placeholder={"Search professional"}
                                            onValueChange={(newValue) => {
                                                setFieldValue("linkedCompanyID", newValue?.value || "");
                                                setFieldValue("linkedCompanyName", newValue?.label || "");
                                            }}
                                            onSearchChange={handleProfessionalSearchChange}
                                            PopUp={true}
                                            searchable={true}
                                            addNew={false}
                                            clientType="professional"
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            <Grid container sx={{ width: "100%", mt: 2 }}>
                                <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                    <p className={styles.dataTitleV2}>Preferred:</p>
                                </Grid>
                                <Grid item xs={9}>
                                    <DropDownV2
                                        options={preferredOptions}
                                        initialSelectedValue={values.preferred}
                                        placeholder={"Select..."}
                                        onValueChange={(newValue) => {
                                            setFieldValue("preferred", newValue);
                                        }}
                                        PopUp={true}
                                        errorState={Boolean(touched.preferred && errors.preferred)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container sx={{ width: "100%", mt: 2 }}>
                                <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                    <p className={styles.dataTitleV2}>Phone No.:</p>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        fullWidth
                                        {...getFieldProps('phoneNo')}
                                        placeholder="Enter phone number"
                                        sx={textfieldStyle}
                                        error={Boolean(touched.phoneNo && errors.phoneNo)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container sx={{ width: "100%", mt: 2 }}>
                                <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                    <p className={styles.dataTitleV2}>Address 1:</p>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        fullWidth
                                        {...getFieldProps('address1')}
                                        placeholder="Enter address line 1"
                                        sx={textfieldStyle}
                                        error={Boolean(touched.address1 && errors.address1)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container sx={{ width: "100%", mt: 2 }}>
                                <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                    <p className={styles.dataTitleV2}>Address 2:</p>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        fullWidth
                                        {...getFieldProps('address2')}
                                        placeholder="Enter address line 2"
                                        sx={textfieldStyle}
                                        error={Boolean(touched.address2 && errors.address2)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container sx={{ width: "100%", mt: 2 }}>
                                <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                    <p className={styles.dataTitleV2}>Town:</p>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        fullWidth
                                        {...getFieldProps('town')}
                                        placeholder="Enter town"
                                        sx={textfieldStyle}
                                        error={Boolean(touched.town && errors.town)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container sx={{ width: "100%", mt: 2 }}>
                                <Grid item xs={3} sx={{ pr: 2, display: "flex", alignItems: "center" }}>
                                    <p className={styles.dataTitleV2}>Post Code:</p>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        fullWidth
                                        {...getFieldProps('postCode')}
                                        placeholder="Enter post code"
                                        sx={textfieldStyle}
                                        error={Boolean(touched.postCode && errors.postCode)}
                                    />
                                </Grid>
                            </Grid>

                            <div className={styles.updateAndCancel}>
                                <div
                                    className={styles.updateButton}
                                    onClick={handleSubmit}
                                >
                                    <div className={buttonStyles.YesButtonComponentStyling}>
                                        UPDATE
                                    </div>
                                </div>
                                <div className={styles.cancelButton} onClick={() => setShowDeleteConfirmation(true)}>
                                    <div className={buttonStyles.NoButtonComponentStyling} style={{ backgroundColor: '#dc3545', color: 'white' }}>
                                        DELETE
                                    </div>
                                </div>
                                <div className={styles.cancelButton} onClick={onClose}>
                                    <div className={buttonStyles.NoButtonComponentStyling}>
                                        CANCEL
                                    </div>
                                </div>
                            </div>

                        </Form>
                    </FormikProvider>

                    {/* Delete Confirmation Dialog */}
                    {showDeleteConfirmation && (
                        <div className={styles.backGround} style={{ zIndex: 1001 }}>
                            <div
                                className={styles.form}
                                style={{
                                    width: "400px",
                                    maxHeight: "200px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "20px",
                                    textAlign: "center"
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div className={styles.sectionTitle} style={{ marginBottom: "20px", color: "#dc3545" }}>
                                    Confirm Delete
                                </div>
                                <p style={{ marginBottom: "20px", fontSize: "16px" }}>
                                    Are you sure you want to delete this client? This action cannot be undone.
                                </p>
                                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                    <div
                                        className={styles.cancelButton}
                                        onClick={() => setShowDeleteConfirmation(false)}
                                        disabled={isDeletingClient}
                                    >
                                        <div className={buttonStyles.NoButtonComponentStyling}>
                                            CANCEL
                                        </div>
                                    </div>
                                    <div
                                        className={styles.updateButton}
                                        onClick={async () => {
                                            try {
                                                await onDelete(clientData.id);
                                                setShowDeleteConfirmation(false);
                                                onClose();
                                            } catch (error) {
                                                // Error is handled in the parent component
                                                setShowDeleteConfirmation(false);
                                            }
                                        }}
                                        disabled={isDeletingClient}
                                    >
                                        <div className={buttonStyles.YesButtonComponentStyling} style={{ backgroundColor: '#dc3545' }}>
                                            {isDeletingClient ? 'DELETING...' : 'DELETE'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <img className={styles.blueLogo} src={BlueLogo} alt="BlueLogo" style={{ alignSelf: 'center' }} />
                </div>
            </div>
    );
};

const EditClientProfileSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    clientType: Yup.mixed().test(
        'clientType-required',
        'Client type is required',
        (val) => !!(val && typeof val === 'object' && ['Professional','Home Owner','Company'].includes(val.value))
    ),
    preferredRunner: Yup.mixed().test(
        'preferredRunner-required',
        'Preferred runner is required',
        (val) => !!(
          val &&
          (
            (typeof val === 'object' && val.value !== undefined && val.value !== null && String(val.value).trim() !== '') ||
            (typeof val === 'string' && val.trim() !== '')
          )
        ),
    ),
    // Make these optional
    phoneNo: Yup.string(),
    address1: Yup.string(),
    town: Yup.string(),
    postCode: Yup.string(),
});

export default EditClientProfilePopup; 